module.exports = __webpack_public_path__ + "img/PfSense.5763a1b.svg";